import React from 'react';
import OpcoesBuscaPopover from '../../../../components/util/opcoesBuscaPopover/.mixins';
import { Fields } from './Fields';
import { useFormsContext } from 'pages/forms/context/FormsProvider';

export const MoreOptionsModal = () => {
  const { handleClearSearch, defineFilters } = useFormsContext();

  return (
    <OpcoesBuscaPopover
      handlerCleanFilters={handleClearSearch}
      handlerAplicarFilters={defineFilters}
      btLabel="Mais opções de busca"
      Children={() => {
        return <Fields />;
      }}
      anchororigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      transformorigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      popoverWidth="40%"
      popoverPadding="2%"
      btvariant="text"
    />
  );
};
